import { LanguageOptions } from "@/Administration/Models/UI/Enums/Administration";
import { UserEditMode } from "@/Administration/Models/UI/Users/UserEditMode";
import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";

interface IFaxCoverSheetClickableTextProps {
    readonly?: boolean;
    userEditMode?: UserEditMode;
    user: EmployeeUIModel;
    languageOptions: LanguageOptions;
    td1Style?: React.CSSProperties;
    tdImportDelete?: React.CSSProperties;
    importClickableText?: React.CSSProperties;
    deleteClickableTextSectionStyle?: React.CSSProperties;
    editTab?: (item: ClickableTextItem) => void;
    showNotePopup?: (noteContext: string) => void;
    openImportClickableTextComponent?: (context: string) => void;
    openWarningDeleteClickableTextSection?: (noteContext: string, sectionName: string, subSectionName: string) => void;
}

function FaxCoverSheetClickableText(props: Readonly<IFaxCoverSheetClickableTextProps>): JSX.Element {
    const { getText } = useTranslation();
    const sectionName = getText("FaxCoverSheet_FaxCoverSheetLabel");
    const lang = sessionStore.getLanguageStringFromEnum(props.languageOptions);
    const isEditMode = props.userEditMode === UserEditMode.Edit;
    const subjects: ClickableTextItem[] = props.user.getAggregatedTabNames("FaxCoverSheetSubject", lang);
    const messages: ClickableTextItem[] = props.user.getAggregatedTabNames("FaxCoverSheetMessage", lang);

    return (
        <div className="psingle-column practice centered">
            <div className="tb">
                <div className="tbc">
                    <div>
                        <table>
                            {!props.readonly ? (
                                <tbody>
                                    <tr>
                                        <td className="c1" style={props.td1Style}>
                                            <label className="form-label padding-xs-right">{getText("SubjectLabel")}</label>
                                            {isEditMode && (
                                                <a role="button" onClick={() => props.showNotePopup?.("FaxCoverSheetSubject")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2">
                                            <strong>
                                                {subjects.length > 0 ? subjects.map((s: ClickableTextItem, i: number, self: ClickableTextItem[]) => (
                                                    <a role="button" key={s.TabOrderIndex} onClick={() => props.editTab?.(s)}>
                                                        {s.TabName} {(i !== self.length - 1) && " , "}
                                                    </a>
                                                )) : "--"
                                                }
                                            </strong>
                                        </td>
                                        <td style={props.tdImportDelete}>
                                            <a role="button" onClick={() => props.openImportClickableTextComponent("FaxCoverSheetSubject")} style={props.importClickableText}>
                                                <strong>{getText("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a role="button" onClick={() => props.openWarningDeleteClickableTextSection("FaxCoverSheetSubject", sectionName, getText("SubjectLabel"))} style={props.deleteClickableTextSectionStyle}>
                                                <strong>{getText("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={props.td1Style}>
                                            <label className="form-label padding-xs-right">{getText("MessagesLabel")}</label>
                                            {isEditMode && (
                                                <a role="button" onClick={() => props.showNotePopup?.("FaxCoverSheetMessage")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2">
                                            <strong>
                                                {messages.length > 0 ? messages.map((m: ClickableTextItem, i: number, self: ClickableTextItem[]) => (
                                                    <a role="button" key={m.TabOrderIndex} onClick={() => props.editTab?.(m)}>
                                                        {m.TabName} {(i !== self.length - 1) && " , "}
                                                    </a>
                                                )) : "--"
                                                }
                                            </strong>
                                        </td>
                                        <td style={props.tdImportDelete}>
                                            <a role="button" onClick={() => props.openImportClickableTextComponent("FaxCoverSheetMessage")} style={props.importClickableText}>
                                                <strong>{getText("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a role="button" onClick={() => props.openWarningDeleteClickableTextSection("FaxCoverSheetMessage", sectionName, getText("MessagesLabel"))} style={props.deleteClickableTextSectionStyle}>
                                                <strong>{getText("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td className="c1 align-top"><label className="form-label">{getText("SubjectLabel")}</label></td>
                                        <td className="c2 align-top"><strong>{MyleHelper.ReplaceEmptyString(subjects.map((p: ClickableTextItem) => p.TabName).join(", "))}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1 align-top"><label className="form-label">{getText("MessageLabel")}</label></td>
                                        <td className="c2 align-top"><strong>{MyleHelper.ReplaceEmptyString(messages.map((p: ClickableTextItem) => p.TabName).join(", "))}</strong></td>
                                    </tr>
                                </tbody>
                            )
                            }
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export { FaxCoverSheetClickableText };
